import { createFileRoute } from '@tanstack/react-router'
import AuthScreen from './-components'

export const Route = createFileRoute('/(auth)/login/')({
  component: () => <AuthScreen />
})